import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { ClinicalPageShell } from "@/components/clinical";
import { CrudShellHeader } from "@/components/ds";
import { WorkspaceHubBack } from "@/components/workspace/WorkspaceHub";
import { OrderReturnsPanel } from "@/components/orders/OrderReturnsPanel";
import { useWorkspaceTenantId } from "@/hooks/use-workspace-tenant-id";
import { MerchantExperienceBar } from "@/components/renata/MerchantExperienceBar";

export const Route = createFileRoute("/app/ordenes/devoluciones")({
  validateSearch: (s: Record<string, unknown>) => ({
    orderId: typeof s.orderId === "string" && s.orderId.trim() ? s.orderId.trim() : undefined,
  }),
  component: OrdenesDevolucionesPage,
  head: () => ({ meta: [{ title: "Devoluciones — Structura Market" }] }),
});

function OrdenesDevolucionesPage() {
  const tid = useWorkspaceTenantId();
  const navigate = useNavigate();
  const { orderId } = Route.useSearch();

  return (
    <div>
      <CrudShellHeader title="Devoluciones" description="Solo desde órdenes entregadas" />
      <ClinicalPageShell offset="none" className="pt-6">
        <MerchantExperienceBar screenId="ordenes-devoluciones" />
        <WorkspaceHubBack
          title="Órdenes"
          onBack={() => void navigate({ to: "/app/ordenes" })}
        />
        {tid ? <OrderReturnsPanel tenantId={tid} orderId={orderId} /> : null}
      </ClinicalPageShell>
    </div>
  );
}
